var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aa"},[_c('div',{staticClass:"box2"},[_c('div',{staticClass:"title"},[_vm._v("联系我们")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info.content)}})]),_c('item6')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }